/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const doDeleteStore = /* GraphQL */ `
  mutation DoDeleteStore($id: String) {
    doDeleteStore(id: $id)
  }
`;
export const doAddToFavorites = /* GraphQL */ `
  mutation DoAddToFavorites($store_id: String, $owner: String!, $dt: Int!) {
    doAddToFavorites(store_id: $store_id, owner: $owner, dt: $dt) {
      id
      store_id
      owner
      createdAt
      updatedAt
    }
  }
`;
export const doCreateStore = /* GraphQL */ `
  mutation DoCreateStore(
    $storemanagers: [String!]
    $security: [String!]
    $name: String!
    $open_time_mon: Int!
    $close_time_mon: Int!
    $open_time_tue: Int!
    $close_time_tue: Int!
    $open_time_wed: Int!
    $close_time_wed: Int!
    $open_time_thu: Int!
    $close_time_thu: Int!
    $open_time_fri: Int!
    $close_time_fri: Int!
    $open_time_sat: Int!
    $close_time_sat: Int!
    $open_time_sun: Int!
    $close_time_sun: Int!
    $address: String!
    $lat: Float!
    $lng: Float!
    $num_persons: Int!
    $duration: Int!
    $timezone: String!
    $phone: String!
    $minutes_before_out: Int!
    $minutes_before_expire: Int!
    $brand_id: String!
  ) {
    doCreateStore(
      storemanagers: $storemanagers
      security: $security
      name: $name
      open_time_mon: $open_time_mon
      close_time_mon: $close_time_mon
      open_time_tue: $open_time_tue
      close_time_tue: $close_time_tue
      open_time_wed: $open_time_wed
      close_time_wed: $close_time_wed
      open_time_thu: $open_time_thu
      close_time_thu: $close_time_thu
      open_time_fri: $open_time_fri
      close_time_fri: $close_time_fri
      open_time_sat: $open_time_sat
      close_time_sat: $close_time_sat
      open_time_sun: $open_time_sun
      close_time_sun: $close_time_sun
      address: $address
      lat: $lat
      lng: $lng
      num_persons: $num_persons
      duration: $duration
      timezone: $timezone
      phone: $phone
      minutes_before_out: $minutes_before_out
      minutes_before_expire: $minutes_before_expire
      brand_id: $brand_id
    ) {
      id
      storemanagers
      security
      name
      open_time_mon
      close_time_mon
      open_time_tue
      close_time_tue
      open_time_wed
      close_time_wed
      open_time_thu
      close_time_thu
      open_time_fri
      close_time_fri
      open_time_sat
      close_time_sat
      open_time_sun
      close_time_sun
      address
      lat
      lng
      num_persons
      duration
      timezone
      phone
      minutes_before_out
      minutes_before_expire
      brand_id
      locked
      currentlyInStore
      createdAt
      updatedAt
    }
  }
`;
export const doUpdateStore = /* GraphQL */ `
  mutation DoUpdateStore(
    $id: String
    $storemanagers: [String!]
    $security: [String!]
    $name: String!
    $open_time_mon: Int!
    $close_time_mon: Int!
    $open_time_tue: Int!
    $close_time_tue: Int!
    $open_time_wed: Int!
    $close_time_wed: Int!
    $open_time_thu: Int!
    $close_time_thu: Int!
    $open_time_fri: Int!
    $close_time_fri: Int!
    $open_time_sat: Int!
    $close_time_sat: Int!
    $open_time_sun: Int!
    $close_time_sun: Int!
    $address: String!
    $lat: Float!
    $lng: Float!
    $num_persons: Int!
    $duration: Int!
    $timezone: String!
    $phone: String!
    $minutes_before_out: Int!
    $minutes_before_expire: Int!
    $brand_id: String!
  ) {
    doUpdateStore(
      id: $id
      storemanagers: $storemanagers
      security: $security
      name: $name
      open_time_mon: $open_time_mon
      close_time_mon: $close_time_mon
      open_time_tue: $open_time_tue
      close_time_tue: $close_time_tue
      open_time_wed: $open_time_wed
      close_time_wed: $close_time_wed
      open_time_thu: $open_time_thu
      close_time_thu: $close_time_thu
      open_time_fri: $open_time_fri
      close_time_fri: $close_time_fri
      open_time_sat: $open_time_sat
      close_time_sat: $close_time_sat
      open_time_sun: $open_time_sun
      close_time_sun: $close_time_sun
      address: $address
      lat: $lat
      lng: $lng
      num_persons: $num_persons
      duration: $duration
      timezone: $timezone
      phone: $phone
      minutes_before_out: $minutes_before_out
      minutes_before_expire: $minutes_before_expire
      brand_id: $brand_id
    ) {
      id
      storemanagers
      security
      name
      open_time_mon
      close_time_mon
      open_time_tue
      close_time_tue
      open_time_wed
      close_time_wed
      open_time_thu
      close_time_thu
      open_time_fri
      close_time_fri
      open_time_sat
      close_time_sat
      open_time_sun
      close_time_sun
      address
      lat
      lng
      num_persons
      duration
      timezone
      phone
      minutes_before_out
      minutes_before_expire
      brand_id
      locked
      currentlyInStore
      createdAt
      updatedAt
    }
  }
`;
export const doEnterStore = /* GraphQL */ `
  mutation DoEnterStore($id: String!, $time: Int!) {
    doEnterStore(id: $id, time: $time) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const doLeaveStore = /* GraphQL */ `
  mutation DoLeaveStore($id: String!, $time: Int!) {
    doLeaveStore(id: $id, time: $time) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const doCreateReservationForTime = /* GraphQL */ `
  mutation DoCreateReservationForTime(
    $store_id: String!
    $owner: String!
    $day_start_dt: Int!
    $day_index: Int!
    $dt: Int!
    $first: Int!
  ) {
    doCreateReservationForTime(
      store_id: $store_id
      owner: $owner
      day_start_dt: $day_start_dt
      day_index: $day_index
      dt: $dt
      first: $first
    ) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const doCreateReservationNextAvailable = /* GraphQL */ `
  mutation DoCreateReservationNextAvailable(
    $store_id: String!
    $owner: String!
    $day_start_dt: Int!
    $day_index: Int!
    $dt: Int!
    $first: Int!
  ) {
    doCreateReservationNextAvailable(
      store_id: $store_id
      owner: $owner
      day_start_dt: $day_start_dt
      day_index: $day_index
      dt: $dt
      first: $first
    ) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const doCancelReservation = /* GraphQL */ `
  mutation DoCancelReservation($reservation_id: String!, $owner: String!) {
    doCancelReservation(reservation_id: $reservation_id, owner: $owner) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const doGetMinuteMap = /* GraphQL */ `
  mutation DoGetMinuteMap($store_id: String!, $dt: Int!, $day_index: Int!) {
    doGetMinuteMap(store_id: $store_id, dt: $dt, day_index: $day_index)
  }
`;
export const createBrand = /* GraphQL */ `
  mutation CreateBrand(
    $input: CreateBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    createBrand(input: $input, condition: $condition) {
      id
      brandmanagers
      name
      image
      security_role_title
      store_manager_role_title
      createdAt
      updatedAt
    }
  }
`;
export const updateBrand = /* GraphQL */ `
  mutation UpdateBrand(
    $input: UpdateBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    updateBrand(input: $input, condition: $condition) {
      id
      brandmanagers
      name
      image
      security_role_title
      store_manager_role_title
      createdAt
      updatedAt
    }
  }
`;
export const deleteBrand = /* GraphQL */ `
  mutation DeleteBrand(
    $input: DeleteBrandInput!
    $condition: ModelBrandConditionInput
  ) {
    deleteBrand(input: $input, condition: $condition) {
      id
      brandmanagers
      name
      image
      security_role_title
      store_manager_role_title
      createdAt
      updatedAt
    }
  }
`;
export const createStore = /* GraphQL */ `
  mutation CreateStore(
    $input: CreateStoreInput!
    $condition: ModelStoreConditionInput
  ) {
    createStore(input: $input, condition: $condition) {
      id
      storemanagers
      security
      name
      open_time_mon
      close_time_mon
      open_time_tue
      close_time_tue
      open_time_wed
      close_time_wed
      open_time_thu
      close_time_thu
      open_time_fri
      close_time_fri
      open_time_sat
      close_time_sat
      open_time_sun
      close_time_sun
      address
      lat
      lng
      num_persons
      duration
      timezone
      phone
      minutes_before_out
      minutes_before_expire
      brand_id
      locked
      currentlyInStore
      createdAt
      updatedAt
    }
  }
`;
export const updateStore = /* GraphQL */ `
  mutation UpdateStore(
    $input: UpdateStoreInput!
    $condition: ModelStoreConditionInput
  ) {
    updateStore(input: $input, condition: $condition) {
      id
      storemanagers
      security
      name
      open_time_mon
      close_time_mon
      open_time_tue
      close_time_tue
      open_time_wed
      close_time_wed
      open_time_thu
      close_time_thu
      open_time_fri
      close_time_fri
      open_time_sat
      close_time_sat
      open_time_sun
      close_time_sun
      address
      lat
      lng
      num_persons
      duration
      timezone
      phone
      minutes_before_out
      minutes_before_expire
      brand_id
      locked
      currentlyInStore
      createdAt
      updatedAt
    }
  }
`;
export const deleteStore = /* GraphQL */ `
  mutation DeleteStore(
    $input: DeleteStoreInput!
    $condition: ModelStoreConditionInput
  ) {
    deleteStore(input: $input, condition: $condition) {
      id
      storemanagers
      security
      name
      open_time_mon
      close_time_mon
      open_time_tue
      close_time_tue
      open_time_wed
      close_time_wed
      open_time_thu
      close_time_thu
      open_time_fri
      close_time_fri
      open_time_sat
      close_time_sat
      open_time_sun
      close_time_sun
      address
      lat
      lng
      num_persons
      duration
      timezone
      phone
      minutes_before_out
      minutes_before_expire
      brand_id
      locked
      currentlyInStore
      createdAt
      updatedAt
    }
  }
`;
export const createDashboardStoreStat = /* GraphQL */ `
  mutation CreateDashboardStoreStat(
    $input: CreateDashboardStoreStatInput!
    $condition: ModelDashboardStoreStatConditionInput
  ) {
    createDashboardStoreStat(input: $input, condition: $condition) {
      id
      dptype
      store_id
      dpindex
      completed
      cancelled
      active
      duration
      favorites
      first
      createdAt
      updatedAt
    }
  }
`;
export const updateDashboardStoreStat = /* GraphQL */ `
  mutation UpdateDashboardStoreStat(
    $input: UpdateDashboardStoreStatInput!
    $condition: ModelDashboardStoreStatConditionInput
  ) {
    updateDashboardStoreStat(input: $input, condition: $condition) {
      id
      dptype
      store_id
      dpindex
      completed
      cancelled
      active
      duration
      favorites
      first
      createdAt
      updatedAt
    }
  }
`;
export const deleteDashboardStoreStat = /* GraphQL */ `
  mutation DeleteDashboardStoreStat(
    $input: DeleteDashboardStoreStatInput!
    $condition: ModelDashboardStoreStatConditionInput
  ) {
    deleteDashboardStoreStat(input: $input, condition: $condition) {
      id
      dptype
      store_id
      dpindex
      completed
      cancelled
      active
      duration
      favorites
      first
      createdAt
      updatedAt
    }
  }
`;
export const createReservation = /* GraphQL */ `
  mutation CreateReservation(
    $input: CreateReservationInput!
    $condition: ModelReservationConditionInput
  ) {
    createReservation(input: $input, condition: $condition) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const updateReservation = /* GraphQL */ `
  mutation UpdateReservation(
    $input: UpdateReservationInput!
    $condition: ModelReservationConditionInput
  ) {
    updateReservation(input: $input, condition: $condition) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const deleteReservation = /* GraphQL */ `
  mutation DeleteReservation(
    $input: DeleteReservationInput!
    $condition: ModelReservationConditionInput
  ) {
    deleteReservation(input: $input, condition: $condition) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const createFavorite = /* GraphQL */ `
  mutation CreateFavorite(
    $input: CreateFavoriteInput!
    $condition: ModelFavoriteConditionInput
  ) {
    createFavorite(input: $input, condition: $condition) {
      id
      store_id
      owner
      createdAt
      updatedAt
    }
  }
`;
export const updateFavorite = /* GraphQL */ `
  mutation UpdateFavorite(
    $input: UpdateFavoriteInput!
    $condition: ModelFavoriteConditionInput
  ) {
    updateFavorite(input: $input, condition: $condition) {
      id
      store_id
      owner
      createdAt
      updatedAt
    }
  }
`;
export const deleteFavorite = /* GraphQL */ `
  mutation DeleteFavorite(
    $input: DeleteFavoriteInput!
    $condition: ModelFavoriteConditionInput
  ) {
    deleteFavorite(input: $input, condition: $condition) {
      id
      store_id
      owner
      createdAt
      updatedAt
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo($input: CreateUserInfoInput!) {
    createUserInfo(input: $input) {
      createdAt
      email
      owner
      phone
      countryShortCode
      receiveEmail
      receivePush
      receiveSMS
      updatedAt
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo($input: UpdateUserInfoInput!) {
    updateUserInfo(input: $input) {
      createdAt
      email
      owner
      phone
      countryShortCode
      receiveEmail
      receivePush
      receiveSMS
      updatedAt
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo($input: DeleteUserInfoInput!) {
    deleteUserInfo(input: $input) {
      createdAt
      email
      owner
      phone
      countryShortCode
      receiveEmail
      receivePush
      receiveSMS
      updatedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.js